import React from "react";
//import PropTypes from 'prop-types';
import "./filesSkeleton.scss";
//import { URAvaratSkeleton } from "./skeletonWidgets/avatar";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URFilesSkeleton } from "./skeletonWidgets/fileSkeleton";
function URFileSkeleton(props: any) {
  return (
    <>
      <div className="skeletonLoading">
        <div className="filesSkeleton">
          <div className="topLine">
            <URLineSkeleton className='line lineThick size10'/>
            <URLineSkeleton className='line lineThick size5'/>
          </div>
          <div className="filesDesc">
            <URFilesSkeleton  className='filesPrev'/>
            <URFilesSkeleton  className='filesPrev'/>
            <URFilesSkeleton  className='filesPrev'/>
          </div>
          <div className="filesList">
            <URLineSkeleton className='line lineThick size60'/>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URFileSkeleton
};